import 'regenerator-runtime/runtime'
import Vue from 'vue'
import ApiService from '@/api/api.service'
import app from './app.vue'
import router from './router'
import store from './store'
import '@/components'
import '@/filters'

import vuetify from './plugins/vuetify'
import './plugins/vuejs-noty'
import './plugins/vuejs-clipboard2'
import './plugins/vue-analytics'
import './plugins/vue-barcode'
import './plugins/html2canvas'
import './plugins/sentry'
import i18n from './plugins/i18n'
import './lib/pronto-css'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false
ApiService.init()

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(app)
}).$mount('#app')
